/**
 * Identity verification status
 * - Verified: Identity verified - either by registration number match or user confirmation
 * - PossibleMatch: Single candidate found but requires user confirmation
 * - ReviewRequired: Multiple candidates found - user must select the correct one
 * - Unverified: No matching candidates found
 * - Pending: Identity verification is in progress (legacy, for backwards compatibility)
 */
export enum IdentityStatus {
    Verified = 'verified',
    PossibleMatch = 'possible-match',
    ReviewRequired = 'review-required',
    Unverified = 'unverified',

    /** @deprecated Use more specific statuses. Kept for backwards compatibility */
    Pending = 'pending',
}
